import { useEffect, useState } from 'react';

import type { GrassCampaignResponseDto } from '@/api/campaign/grass/grass.dto';

import * as D from './data';

export const useTreeState = (
  grassData: GrassCampaignResponseDto | null,
  totalContributionData: number,
) => {
  const [currentPhase, setCurrentPhase] = useState(0);
  const [fillCount, setFillCount] = useState(0);

  useEffect(() => {
    const totalContributions = totalContributionData;

    if (totalContributions === 0) {
      setCurrentPhase(0);
      setFillCount(0);
      return;
    }

    const currentPixelNumber = Math.ceil(
      totalContributions / D.CONTRIBUTIONS_PER_PIXEL,
    );

    const phase = Math.max(
      Math.min(
        Math.floor(totalContributions / 200000) * 2 + 1,
        D.TREE_LAYERS.length - 1,
      ),
      1,
    );

    let pixelsToFill;
    if (totalContributions >= 200000) {
      const contributionsInCurrentPhase = totalContributions % 200000;
      pixelsToFill = Math.min(
        Math.ceil(contributionsInCurrentPhase / D.CONTRIBUTIONS_PER_PIXEL),
        D.TOTAL_PIXELS,
      );
    } else {
      pixelsToFill = Math.max(Math.min(currentPixelNumber, D.TOTAL_PIXELS), 1);
    }

    setCurrentPhase(phase);
    setFillCount(pixelsToFill);
  }, [totalContributionData]);

  return { currentPhase, fillCount };
};

export const calculateUserContribution = (
  grassData: GrassCampaignResponseDto | null,
) => {
  const userStartPixel = grassData?.startPixel || 0;
  const userPixelCount = grassData?.pixelCount || 0;

  return {
    startPixel: userStartPixel,
    pixelCount: userPixelCount,
  };
};
